export const APP_ROLES = {
    ADMINISTRATOR: 'c857bcd0-5501-4ea3-a8eb-ddb9f81a2905',
    COMPANY_OWNER: 'e2c2c17e-3314-46a2-8114-e395a535d6da',
    TERMINAL: '1e3894d8-5f19-45dc-9a8a-27b25ac9ab2c',
};

export enum APP_ROLES_NAMES {
    ADMINISTRATOR = 'ADMINISTRATOR',
    COMPANY_OWNER = 'COMPANY_OWNER',
    MANAGER = 'MANAGER',
}
